import fieldLabels from './fieldLabels'

export default [
  {
    title: 'Keyword',
    field: 'keyword',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    topCalc (values, data, calcParams) {
      return (calcParams.filteredKeywords || 0).toLocaleString('en')
    },
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    cellDblClick (e, cell) {
      window.open('https://www.google.com/search?q=' + encodeURI(cell._cell.value), '_blank').focus()
    },
    cellDblClickDescription: 'double-click cell to open google search in new tab'
  },
  {
    title: fieldLabels['metric_msv_broad_adjusted_1'],
    field: 'metric_msv_broad_adjusted_1',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    topCalc (values, data, calcParams) {
      return (calcParams.filteredMsv.metric_msv_broad_adjusted_1 || 0).toLocaleString('en')
    },
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    }
  },
  {
    title: 'Rel Score',
    field: 'score',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    topCalc: 'avg',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    width: 50,
    editor: 'select',
    editorParams: {
      values: {
        '-1': '-1',
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5'
      }
    },
    cellContext: function (e, cell) {
      var _filters = this.getFilters()
      _filters.push({ field: cell._cell.column.field, type: '=', value: cell._cell.value.toString() })
      this.setFilter(_filters)
    },
    cellContextDescription: 'right-click cell to apply score filter'
  },
  {
    title: 'Mapped URL',
    field: 'url',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: []
    },
    cellDblClick: function (e, cell) {
    },
    cellContext: function (e, cell) {
    },
    cellContextDescription: 'right-click cell to apply URL filter',
    cellDblClickDescription: 'double-click cell to open URL in new tab',
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    },
    formatter: 'lookup',
  },
  {
    title: 'Published URL',
    field: 'published_url',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    editor: 'autocomplete',
    editorParams: {
      showListOnEmpty: true,
      freetext: false,
      values: []
    },
    cellDblClick: function (e, cell) {
    },
    cellContext: function (e, cell) {
    },
    cellContextDescription: 'right-click cell to apply Published URL filter',
    cellDblClickDescription: 'double-click cell to open URL in new tab',
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    },
    formatter: 'lookup',
  },
  {
    title: 'Section',
    field: 'section',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    cellContext: function (e, cell) {
      var _filters = this.getFilters()
      _filters.push({ field: cell._cell.column.field, type: 'Containing', value: cell._cell.value })
      this.setFilter(_filters)
    },
    cellContextDescription: 'right-click cell to apply section filter'
  },
  {
    title: 'URL Status',
    field: 'url_status',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    cellContext: function (e, cell) {
      var _filters = this.getFilters()
      _filters.push({ field: cell._cell.column.field, type: '=', value: cell._cell.value })
      this.setFilter(_filters)
    },
    cellContextDescription: 'right-click cell to apply status filter',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    }
  },
  {
    title: 'Page Type',
    field: 'url_page_type',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true
  },
  {
    title: fieldLabels['metric_rank_current'],
    field: 'metric_rank_current',
    width: 50,
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: 'in',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: 'double-click cell to open history modal'
  },
  {
    visible: false,
    title: 'SERP: Answer Box',
    field: 'answer_box',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'Rank Timestamp',
    field: 'metric_rank_timestamp_current',
    sorter: 'date',
    headerSortStartingDir: 'desc',
    resizable: true
  },
  {
    visible: false,
    title: 'Baseline Rank Timestamp',
    field: 'metric_rank_timestamp_baseline',
    sorter: 'date',
    headerSortStartingDir: 'desc',
    resizable: true
  },
  {
    visible: false,
    title: 'Matched URLs',
    field: 'url_match',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing'
  },
  {
    visible: false,
    title: 'SERP: PAA',
    field: 'people_also_ask',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },

  {
    visible: false,
    title: 'SERP: Local 3 Pack',
    field: 'local_3_pack',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Video Pack',
    field: 'video_pack',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: News Pack',
    field: 'news_pack',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Brand Pack',
    field: 'brand_pack',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Image Pack',
    field: 'image_pack',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Knowledge Graph',
    field: 'knowledge_graph',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Related Searches',
    field: 'related_searches',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Shopping Box',
    field: 'shopping_box',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: {
        'false': 'false',
        'true': 'true'
      }
    }
  },
  {
    visible: false,
    title: 'SERP: Ad Count',
    field: 'ad_count',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: '='
  },
  {
    visible: false,
    title: 'SERP: Geo',
    field: 'geo',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing'
  },
  {
    visible: false,
    title: 'SERP: Locale',
    field: 'locale',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: 'Containing'
  },
  {
    visible: false,
    title: 'SERP: Total Results',
    field: 'total_number_of_results',
    sorter: 'string',
    headerSortStartingDir: 'desc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: '='
  },
  {
    visible: false,
    title: 'Rank Zone',
    field: 'metric_rank_zone_current',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true,
    headerFilter: 'input',
    headerFilterFunc: '='

  },
  {
    visible: false,
    title: 'Baseline Rank Zone',
    field: 'metric_rank_zone_baseline',
    sorter: 'string',
    headerSortStartingDir: 'asc',
    resizable: true
    // headerFilter: 'input',
    // headerFilterFunc: '='

  },
  {
    visible: false,
    title: fieldLabels['rank_current_url'],
    field: 'rank_current_url',
    width: 50,
    sorter: 'string',
    headerSortStartingDir: 'asc',
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    resizable: true,
    cellDblClick: function (e, cell) {
      window.open(cell._cell.value, '_blank').focus()
    },
    cellDblClickDescription: 'double-click cell to open URL in new tab',
    formatter: function (cell) {
      cell.getElement().setAttribute('private-content', true)
      return cell.getValue()
    }
  },
  {
    visible: false,
    title: fieldLabels['rank_baseline_url'],
    field: 'rank_baseline_url',
    width: 50,
    sorter: 'string',
    headerSortStartingDir: 'asc',
    headerFilter: 'input',
    headerFilterFunc: 'Containing',
    resizable: true,
    cellDblClick: function (e, cell) {
      window.open(cell._cell.value, '_blank').focus()
    },
    cellDblClickDescription: 'double-click cell to open URL in new tab'
  },
  {
    visible: false,
    title: fieldLabels['metric_rank_baseline'],
    field: 'metric_rank_baseline',
    width: 50,
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    }
  },
  {
    visible: false,
    title: fieldLabels['metric_msv_broad_adjusted_2'],
    field: 'metric_msv_broad_adjusted_2',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    topCalc (values, data, calcParams) {
      return (calcParams.filteredMsv.metric_msv_broad_adjusted_2 || 0).toLocaleString('en')
    },
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    }
  },
  {
    visible: false,
    title: fieldLabels['metric_msv_broad_adjusted_3'],
    field: 'metric_msv_broad_adjusted_3',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    topCalc (values, data, calcParams) {
      return (calcParams.filteredMsv.metric_msv_broad_adjusted_3 || 0).toLocaleString('en')
    },
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    }
  },
  {
    visible: false,
    title: fieldLabels['metric_msv_broad_adjusted_4'],
    field: 'metric_msv_broad_adjusted_4',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    topCalc (values, data, calcParams) {
      return (calcParams.filteredMsv.metric_msv_broad_adjusted_4 || 0).toLocaleString('en')
    },
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    }
  },
  {
    visible: false,
    title: fieldLabels['content_brief_status'],
    field: 'content_brief_status',
    sorter: 'string',
    width: 50,
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true,
    formatter: 'lookup',
    cellDblClick: function (e, cell) {
      window.open('/dashboard#/content-briefs/' + cell._cell.value, '_blank').focus()
    },
    cellDblClickDescription: 'double-click cell to open content brief in new tab'
  },
  {
    visible: false,
    title: fieldLabels['writing_status'],
    field: 'writing_status',
    sorter: 'string',
    width: 50,
    headerSortStartingDir: 'asc',
    headerFilterFunc: 'in',
    headerFilter: 'select',
    headerFilterParams: {
      values: [],
      multiselect: true,
      sortValuesList: 'asc',
      elementAttributes: {
        class: 'no-x'
      }
    },
    resizable: true
  },
  {
    visible: false,
    title: fieldLabels['difficulty_score'],
    field: 'difficulty_score',
    sorter: 'number',
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    width: 50,
    headerSortStartingDir: 'asc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    resizable: true
  },
  {
    title: fieldLabels['rank_blur_count'],
    field: 'rank_blur_count',
    width: 50,
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    cellDblClick: function (e, cell) {
    },
    cellDblClickDescription: 'double-click cell to open history modal'
  },
  {
    visible: false,
    title: 'Product Grids',
    field: 'product_grids',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    topCalc (values, data, calcParams) {
      return (calcParams.filteredProductData.product_grids || 0).toLocaleString('en')
    },
  },
  {
    visible: false,
    title: 'Total Product Cards',
    field: 'total_product_cards',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editor: 'number',
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    topCalc (values, data, calcParams) {
      return (calcParams.filteredProductData.total_product_cards || 0).toLocaleString('en')
    },
  },
  {
    visible: false,
    title: 'Your Store\'s Cards',
    field: 'seller_cards',
    sorter: 'number',
    headerSortStartingDir: 'desc',
    headerFilter: 'input',
    headerFilterFunc: '=',
    width: 50,
    editorParams: {},
    formatter: 'money',
    formatterParams: {
      thousand: ',',
      precision: false
    },
    topCalc (values, data, calcParams) {
      return (calcParams.filteredProductData.seller_cards || 0).toLocaleString('en')
    },
  },
]
